// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2021-08-19 02:54:53 +0200 (Thu, 19 Aug 2021) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 120943 $
//  Purpose   : config wiki templates
// =============================================================================
// ---Third-party imports
import React, {useState} from 'react'
import {Item, Segment} from 'semantic-ui-react'
import clsx from 'clsx'

// ---Framework imports
import log from 'uix/logging'
import {keys, dict, strip} from 'ldash'
import {useActions} from 'uix/hooks'
import {hashObj} from 'uix/utils'
import {TagMatcher} from 'uix/wiki/utils'
import {HeaderSegment} from 'uix/components'

// ---Local imports
import {DomainConfigTable} from './components'

// ---Exports

export const DomainConfig = TagMatcher(
  'DomainConfig',
  ({section, names, text, ...props}) => {
    if (text) {
      names = text
    }
    names = names
      ? names
          .split(',')
          .map(n => strip(n))
          .filter(n => n)
      : names
    let portal = hashObj([section, names])
    return (
      <HeaderSegment icon="configure" header="Konfiguration" portal={portal}>
        <DomainConfigTable menu="basic" flat menuPortal={portal} names={names} section={section} />
      </HeaderSegment>
    )
  },
  {section: ['domain'], names: ['domain.color']},
  'Configure Domain (element text is interpreted as comma separated options pathes)'
)
